import React, { useState, useEffect, useContext } from "react";
import { FirebaseContext } from "../../FirebaseContext";
import { Stages } from "./Stages/";
import { SelectClass } from './SelectClass/';
import { ClassInfo } from "./SelectClass/ClassInfo";
import { SelectBackground } from './SelectBackground/';
import { BackgroundInfo } from "./SelectBackground/BackgroundInfo";
import { SelectSpecies } from './SelectSpecies/';
import { SpeciesInfo } from "./SelectSpecies/SpeciesInfo";
import { SelectAbility } from './SelectAbility/';
import { AbilityInfo } from './SelectAbility/AbilityInfo'
import './CharacterCreation.css';
import dndWallpaper from '../../Images/wallpapers/dnd-wallpaper.webp';
import wizardWallpaper from '../../Images/wallpapers/classes/wizard.webp';
import barbarianWallpaper from '../../Images/wallpapers/classes/barbarian.webp';
import bardWallpaper from '../../Images/wallpapers/classes/bard.webp';
import clericWallpaper from '../../Images/wallpapers/classes/cleric.webp';
import druidWallpaper from '../../Images/wallpapers/classes/druid.webp';
import fighterWallpaper from '../../Images/wallpapers/classes/fighter.webp';
import monkWallpaper from '../../Images/wallpapers/classes/monk.webp';
import paladinWallpaper from '../../Images/wallpapers/classes/paladin.webp';
import rangerWallpaper from '../../Images/wallpapers/classes/ranger.webp';
import rogueWallpaper from '../../Images/wallpapers/classes/rogue.webp';
import sorcererWallpaper from '../../Images/wallpapers/classes/sorcerer.webp';
import warlockWallpaper from '../../Images/wallpapers/classes/warlock.webp';
import acolyteWallpaper from '../../Images/wallpapers/backgrounds/acolyte.webp';
import artisanWallpaper from '../../Images/wallpapers/backgrounds/artisan.webp';
import charlatanWallpaper from '../../Images/wallpapers/backgrounds/charlatan.webp';
import criminalWallpaper from '../../Images/wallpapers/backgrounds/criminal.webp';
import entertainerWallpaper from '../../Images/wallpapers/backgrounds/entertainer.webp';
import farmerWallpaper from '../../Images/wallpapers/backgrounds/farmer.webp';
import guardWallpaper from '../../Images/wallpapers/backgrounds/guard.webp';
import guideWallpaper from '../../Images/wallpapers/backgrounds/guide.webp';
import hermitWallpaper from '../../Images/wallpapers/backgrounds/hermit.webp';
import merchantWallpaper from '../../Images/wallpapers/backgrounds/merchant.webp';
import nobleWallpaper from '../../Images/wallpapers/backgrounds/noble.webp';
import sageWallpaper from '../../Images/wallpapers/backgrounds/sage.webp';
import sailorWallpaper from '../../Images/wallpapers/backgrounds/sailor.webp';
import scribeWallpaper from '../../Images/wallpapers/backgrounds/scribe.webp';
import soldierWallpaper from '../../Images/wallpapers/backgrounds/soldier.webp';
import wayfarerWallpaper from '../../Images/wallpapers/backgrounds/wayfarer.webp';
import aasimarWallpaper from '../../Images/wallpapers/species/aasimar.webp';
import dragonbornWallpaper from '../../Images/wallpapers/species/dragonborn.webp';
import dwarfWallpaper from '../../Images/wallpapers/species/dwarf.webp';
import elfWallpaper from '../../Images/wallpapers/species/elf.webp';
import gnomeWallpaper from '../../Images/wallpapers/species/gnome.webp';
import goliathWallpaper from '../../Images/wallpapers/species/goliath.webp';
import halflingWallpaper from '../../Images/wallpapers/species/halfling.webp';
import humanWallpaper from '../../Images/wallpapers/species/human.webp';
import orcWallpaper from '../../Images/wallpapers/species/orc.webp';
import tieflingWallpaper from '../../Images/wallpapers/species/tiefling.webp';

export const CharacterCreation = () => {
    const { characterJSON } = useContext(FirebaseContext);

    const getClassWallpaper = () => {
        switch (characterJSON.class) {
            case 'Wizard':
                return wizardWallpaper;
            case 'Barbarian':
                return barbarianWallpaper;
            case 'Bard':
                return bardWallpaper;
            case 'Cleric':
                return clericWallpaper;
            case 'Druid':
                return druidWallpaper;
            case 'Fighter':
                return fighterWallpaper;
            case 'Monk':
                return monkWallpaper;
            case 'Paladin':
                return paladinWallpaper;
            case 'Ranger':
                return rangerWallpaper;
            case 'Rogue':
                return rogueWallpaper;
            case 'Sorcerer':
                return sorcererWallpaper;
            case 'Warlock':
                return warlockWallpaper;
            default:
                return null; // Return null if no class is selected
        }
    };

    const getBackgroundWallpaper = () => {
        switch (characterJSON.background) {
            case 'Acolyte':
                return acolyteWallpaper;
            case 'Artisan':
                return artisanWallpaper;
            case 'Charlatan':
                return charlatanWallpaper;
            case 'Criminal':
                return criminalWallpaper;
            case 'Entertainer':
                return entertainerWallpaper;
            case 'Farmer':
                return farmerWallpaper;
            case 'Guard':
                return guardWallpaper;
            case 'Guide':
                return guideWallpaper;
            case 'Hermit':
                return hermitWallpaper;
            case 'Merchant':
                return merchantWallpaper;
            case 'Noble':
                return nobleWallpaper;
            case 'Sage':
                return sageWallpaper;
            case 'Sailor':
                return sailorWallpaper;
            case 'Scribe':
                return scribeWallpaper;
            case 'Soldier':
                return soldierWallpaper;
            case 'Wayfarer':
                return wayfarerWallpaper;
            default:
                return null; // Return null if no background is selected
        }
    };

    const getSpeciesWallpaper = () => {
        switch (characterJSON.species) {
            case 'Aasimar':
                return aasimarWallpaper;
            case 'Dragonborn':
                return dragonbornWallpaper;
            case 'Dwarf':
                return dwarfWallpaper;
            case 'Elf':
                return elfWallpaper;
            case 'Gnome':
                return gnomeWallpaper;
            case 'Goliath':
                return goliathWallpaper;
            case 'Halfling':
                return halflingWallpaper;
            case 'Human':
                return humanWallpaper;
            case 'Orc':
                return orcWallpaper;
            case 'Tiefling':
                return tieflingWallpaper;
            default:
                return null; // Return null if no species is selected
        }
    }

    const getAbilityWallpaper = () => {
        return null;
    }

    // Function to preload all images
    const preloadImages = (imageUrls) => {
        imageUrls.forEach((url) => {
            const img = new Image();
            img.src = url; // Preload the image by setting the src
        });
    };

    // Preload wallpapers when the component mounts
    useEffect(() => {
        const images = [dndWallpaper, wizardWallpaper, barbarianWallpaper];
        preloadImages(images);
    }, []); // Empty dependency array ensures this runs only once

    const [currentStage, setCurrentStage] = useState("class");

    // Rendering the component based on the current stage
    const renderStage = () => {
        switch (currentStage) {
            case "class":
                return <SelectClass />;
            case "background":
                return <SelectBackground />;
            case "species":
                return <SelectSpecies />;
            case "ability":
                return <SelectAbility />;
            // Add more cases here for the remaining stages
            default:
                return <SelectClass />;
        }
    };

    const renderInfo = () => {
        switch (currentStage) {
            case "class":
                return <ClassInfo charClass={characterJSON.class} />;
            case "background":
                return <BackgroundInfo charBackground={characterJSON.background} />;
            case "species":
                return <SpeciesInfo charSpecies={characterJSON.species} />;
            case "ability":
                return <AbilityInfo />;
            // Add more cases here for the remaining stages
            default:
                return <></>;
        }
    };

    const wallpaper = currentStage === 'species' 
    ? getSpeciesWallpaper() 
    : currentStage === 'background' 
        ? getBackgroundWallpaper() 
        : currentStage === 'ability' // Added case for 'ability'
            ? getAbilityWallpaper() 
            : getClassWallpaper();

    return (
        <>
            <div className="character-creation-container">
                {/* <button onClick={() => console.log(characterJSON)}>TEST</button> */}
                <div className="left-wallpaper">
                    {wallpaper && (
                        <img 
                            src={wallpaper} 
                            alt="Character Wallpaper" 
                            className="wallpaper-image" 
                        />
                    )}
                    <div className="wallpaper-text">
                        {renderInfo()}
                    </div>
                </div>
                <div className="right-content">
                    <Stages 
                        currentStage={currentStage} 
                        setCurrentStage={setCurrentStage}
                    />
                    {renderStage()}
                </div>
            </div>
        </>
    );    
};
